import { render } from "./ConfirmNotification.vue?vue&type=template&id=1860ba9b"
import script from "./ConfirmNotification.vue?vue&type=script&lang=js"
export * from "./ConfirmNotification.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__